import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SyncState } from '@era/locations-sdk';

import * as fromReducer from './device-sync-status.reducer';
import { DeviceSyncStatusState } from './device-sync-status.state';

import { DevicesRouterStoreSelectors } from '../../../../stores/router';

export const selectDeviceSyncStatusState = createFeatureSelector<DeviceSyncStatusState>(
  fromReducer.deviceSyncStatusFeatureKey
);

export const selectDeviceSyncStatusIds = createSelector(
  selectDeviceSyncStatusState,
  fromReducer.selectDeviceSyncStatusIds
);

export const selectDeviceSyncStatusEntities = createSelector(
  selectDeviceSyncStatusState,
  fromReducer.selectDeviceSyncStatusEntities
);

export const selectAllDeviceSyncStatuses = createSelector(
  selectDeviceSyncStatusState,
  fromReducer.selectDeviceSyncStatuses
);

export const selectCurrentDeviceSyncStatus = createSelector(
  selectDeviceSyncStatusEntities,
  DevicesRouterStoreSelectors.selectUdid,
  (entities, udid) => {
    const status = udid && entities?.[udid];
    return status
      ? status
      : {
          udid,
        };
  }
);

export const selectIsDeviceInCorrectSyncState = (deviceId: string) =>
  createSelector(selectDeviceSyncStatusEntities, (entities) => {
    const status = entities?.[deviceId];

    return status
      ? status.wifiProfiles &&
          (status.wifiProfiles == SyncState.Successful || status.wifiProfiles == SyncState.Verify) &&
          status.notificationProfiles &&
          (status.notificationProfiles == SyncState.Successful || status.notificationProfiles == SyncState.Verify) &&
          status.appLockProfile &&
          (status.appLockProfile == SyncState.Successful || status.appLockProfile == SyncState.Verify) &&
          status.applicationConfigurations &&
          (status.applicationConfigurations == SyncState.Successful ||
            status.applicationConfigurations == SyncState.Verify) &&
          status.applications &&
          (status.applications == SyncState.Successful || status.applications == SyncState.Verify) &&
          status.restrictionsProfiles &&
          (status.restrictionsProfiles == SyncState.Successful || status.restrictionsProfiles == SyncState.Verify) &&
          status.airPlaySecurityProfile &&
          (status.airPlaySecurityProfile == SyncState.Successful ||
            status.airPlaySecurityProfile == SyncState.Verify) &&
          status.configurationProfiles &&
          (status.configurationProfiles == SyncState.Successful || status.configurationProfiles == SyncState.Verify)
      : false;
  });
